import { gql } from '@apollo/client';

export const QUERY_WEBHOOK_CONFIG = gql`
  query QueryWebhookConfig {
    webhookConfigs: webhook_configs(limit: 1) {
      id
      orgId
      url
      enabledAt
      createdAt
      updatedAt
      webhookConfigEventSubscriptions: webhook_config_event_subscriptions {
        eventType
      }
    }
  }
`;
